import React, { useEffect, useState } from "react";
import '../styles/CheckoutWallet.css';

const backendURL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const CheckoutWallet = ({ onClose, onSelectAmount }) => {
  const [deadlinePassed, setDeadlinePassed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    async function checkDeadline() {
      try {
        const res = await fetch(`${backendURL}/api/gameweek/status`);
        if (!res.ok) throw new Error("Failed to fetch status");
        const data = await res.json();
        setDeadlinePassed(!data.isOpen);
      } catch (err) {
        console.error("Error checking deadline:", err);
        setError("Unable to check gameweek status. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    checkDeadline();
  }, []);

  const handleSelect = (amount) => {
    setSelectedAmount(amount);
  };
  
  const handleConfirm = () => {
    if (selectedAmount) {
      onSelectAmount(selectedAmount); // Step 2: call the parent handler
    }
  };

  const handleCancelSelection = () => {
    setSelectedAmount(null); // Allow user to cancel selection
  };

  return (
    <div className="checkout-wallet-overlay">
      <div className="checkout-wallet-container">
        <button className="checkout-wallet-close" onClick={onClose}>
          ×
        </button>
        <h3 className="checkout-wallet-title">Select Entry Amount</h3>
        <div className="checkout-wallet-buttons">
          <button
            onClick={() => handleSelect(50)}
            disabled={deadlinePassed || loading}
          >
            Join for 50
          </button>
          <button
            onClick={() => handleSelect(100)}
            disabled={deadlinePassed || loading}
          >
            Join for 100
          </button>
          <button
            onClick={() => handleSelect(250)}
            disabled={deadlinePassed || loading}
          >
            Join for 250
          </button>
        </div>
        {loading && <p>Checking deadline...</p>}
        {error && <p className="error-message">{error}</p>}
        {!loading && deadlinePassed && (
          <p className="deadline-message">
            The deadline for this gameweek has passed.
          </p>
        )}

        
        {/* Confirm selection flow */}
        {selectedAmount && !deadlinePassed && (
          <div className="confirm-selection">
            <p>You're about to join for {selectedAmount}. Confirm?</p>
            <button onClick={handleConfirm}>Confirm</button>
            <button onClick={handleCancelSelection}>Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutWallet;
